import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as styles from '~src/styles/domains/noi/NOIPage.module.scss';
import { MAX_POLL_CALLS } from '~src/utils/constants';
import { trackPageMount } from '~src/utils/tracking';
import { Page } from '../common/enums/api';
import { general } from '../common/state/commonReducer';
import * as commonSelectors from '../common/state/commonSelectors';
import { SessionCreditBureauType } from '../common/types/api';

const CreditFreezeLink = () => {
  const { t } = useTranslation();
  const creditBureau = useSelector(
    commonSelectors.creditBureauSelector,
  ) as SessionCreditBureauType;

  return (
    <a
      href={creditBureau.credit_freeze_url}
      target='_blank'
      rel='noreferrer'
      style={{ textDecoration: 'underline' }}
    >
      {t('creditFreeze:creditFreezeLink', { bureauName: creditBureau.name })}
    </a>
  );
};

export default function CreditFreezePage() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const brand = useSelector(commonSelectors.brandSelector);
  const creditBureau = useSelector(
    commonSelectors.creditBureauSelector,
  ) as SessionCreditBureauType;

  useEffect(() => {
    dispatch(trackPageMount(Page.CREDIT_FREEZE));
    dispatch(
      general({
        isOfferExpired: true,
        pollCallCount: MAX_POLL_CALLS,
      }),
    );
  }, []);

  const header = t('creditFreeze:header', { bureauName: creditBureau.name });
  const greeting = t('creditFreeze:greeting');
  const nextSteps = (
    <Trans
      t={t}
      i18nKey={`creditFreeze:${brand.toLowerCase()}.nextSteps`}
      components={{ CreditFreezeLink: <CreditFreezeLink /> }}
      values={{ bureauName: creditBureau.name }}
    />
  );
  const thanks = t(`creditFreeze:${brand.toLowerCase()}.thanks`);

  return (
    <div className={styles.body} data-auto='creditFreezeBody'>
      <div className={`header-txt ${styles.header}`} data-auto='header'>
        {header}
      </div>
      <div className={styles.text} data-auto='text'>
        <p data-auto='greeting'>{greeting}</p>
        <p data-auto='nextSteps'>{nextSteps}</p>
        <p data-auto='thanks'>{thanks}</p>
      </div>
    </div>
  );
}
